
import { Component, Prop, Vue } from 'vue-property-decorator'
import UserWrap from '@/components/UserWrap'
import { State, Action } from 'vuex-class'
import ChatInput from '@/components/ChatInput.vue'
import ImgViewer from '@/components/ImgPreviewWrap.vue'
import UserImg from '@/components/UserImg'
import { IPostChatMessageStack, IChatMessageStack } from '../IStore'
import { getPreviewImage } from '../Util'
@Component({
  components: {
    UserWrap,
    ChatInput,
    ImgViewer,
    UserImg
  }
})
export default class ChatRoom extends Vue {
  @State('name') name!: string
  @State('userImg') userImg!: number
  @State('friends') friends!: { name: string, img: number, active: number }[]
  @State('chat') chat!: IChatMessageStack
  @Action('postMessageStack') postMessage!: (message: IPostChatMessageStack) => void | false
  @Action('logout') _logout!: Function
  private onSearch = false
  private imgPreviewSrc = ''
  private imgPreviewOnShow = false
  private colorList = ['#ffffff', '#FF9B9B', '#6FE2C3', '#C98CFD', '#69D1FF']

  searchToggle () {
    this.onSearch = !this.onSearch
  }

  async inputOnPost (arg: { text: string, img: FileList, file: FileList }) {
    console.log(arg)
    let { text, img, file } = arg
    let imgs: string[] = []
    let files: { name: string, src: string }[] = []
    this.postMessage({
      name: this.name,
      userImg: this.userImg,
      color: this.colorList[0],
      created_at: '' + (~~(+new Date() / 1000)),
      contentText: text,
      contentImg: img,
      contentFiles: file
    })
    this.postMessage({
      name: 'Foodie',
      userImg: 2,
      color: this.colorList[1],
      created_at: '' + (~~(+new Date() / 1000)),
      contentText: 'This is Echo: \n' + text,
      contentImg: img,
      contentFiles: file
    })
  }

  logout () {
    this._logout()
    this.$router.push('/')
  }

  getRealTime (time: string) {
    let _time = new Date(+time * 1000)
    return `${_time.getHours() % 13} : ${('0' + _time.getMinutes()).slice(-2)} ${_time.getHours() > 12 ? 'pm' : 'am'}`
  }

  imgOnClick (src: string) {
    this.imgPreviewSrc = src
    this.imgPreviewOnShow = true
  }

  imgPreviewOnClick () {
    this.imgPreviewOnShow = false
  }
}
